import { render, staticRenderFns } from "./ModalFormForgottenPassword.vue?vue&type=template&id=e722a5e2&scoped=true&"
import script from "./ModalFormForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./ModalFormForgottenPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e722a5e2",
  null
  
)

export default component.exports